<template>
  <div>
    <el-form
      :inline="true"
      :model="formData"
      class="demo-form-inline"
      :rules="rules"
      label-width="124px"
    >
      <el-form-item label="主办单位：" prop="organizer">
        <span class="form-item-text">{{ projectDetailData.organizer }}</span>
      </el-form-item>
      <el-form-item label="合同金额：">
        <span class="form-item-text">{{ projectDetailData.price }}</span>
      </el-form-item>
      <el-form-item label="承办单位：" prop="undertaker">
        <span class="form-item-text">{{ projectDetailData.undertaker }}</span>
      </el-form-item>
      <el-form-item label="所属营销分公司：">
        <span class="form-item-text">{{ projectDetailData.branch }}</span>
      </el-form-item>
      <el-form-item label="项目编码：" class="note">
        <div v-if="is_show" class="flex_X">
          <!-- <span>{{ formData.projectCode }}</span> -->
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              {{ formData.projectCode }}
            </div>
            <span
              ref="codeElement"
              class="word_wrap note_content ellipsis form-item-text"
              >{{ formData.projectCode }}</span
            >
          </el-tooltip>
          <i
            class="el-icon-edit ml6 fs18 c-main pointer"
            @click="updateBtn"
            :style="{ marginTop: formData.projectCode ? '0px' : '10px' }"
          ></i>
        </div>
        <div v-else class="flex_X">
          <el-input
            v-model="projectCode"
            placeholder="项目编码"
            clearable
            class="mr8"
            :maxlength="50"
          ></el-input>
          <el-button size="small" type="primary" @click="editorFn(1)">保存</el-button>
          <el-button size="small" @click="cancelFn">取消</el-button>
        </div>
      </el-form-item>
      <el-form-item label="业务负责人：">
        <span class="form-item-text">{{ projectDetailData.director }}</span>
      </el-form-item>
      <el-form-item label="项目类型：" prop="projectType">
        <el-select v-model="formData.projectType" placeholder="选择项目类型" disabled>
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in projectTypeArr"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目办负责人：">
        <span class="form-item-text">{{ projectDetailData.project_director }}</span>
      </el-form-item>
      <el-form-item label="项目级别：" prop="projectGrade">
        <el-select v-model="formData.projectGrade" placeholder="选择项目级别" disabled>
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in projectGradeArr"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="实施部门：">
        <span class="form-item-text">{{
          projectDetailData.enforcement_departments
        }}</span>
      </el-form-item>
      <el-form-item label="项目模式：" prop="projectModel">
        <el-select v-model="formData.projectModel" placeholder="选择项目模式" disabled>
          <el-option
            :label="item.name"
            :value="item.id"
            v-for="(item, index) in projectModel"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="实施负责人：">
        <span class="form-item-text">{{ projectDetailData.enforcement_director }}</span>
      </el-form-item>
      <el-form-item label="项目备注：" class="note">
        <div v-if="is_show2" class="flex_X">
          <!-- <span class="note_content ellipsis">{{
              formData.projectName
            }}</span> -->
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              {{ formData.projectName }}
            </div>
            <span
              ref="noteElement"
              class="note_content word_wrap ellipsis form-item-text"
              >{{ formData.projectName }}</span
            >
            <!-- :class="{ note_content: is_have, ellipsis: is_ellipsis }" -->
          </el-tooltip>
          <i
            class="el-icon-edit ml6 fs18 c-main pointer"
            :style="{ marginTop: formData.projectName ? '0px' : '10px' }"
            @click="updateBtn2"
          ></i>
        </div>
        <div v-else class="flex_X">
          <el-input
            v-model="projectName"
            placeholder="项目备注"
            clearable
            class="mr8"
          ></el-input>
          <el-button size="small" type="primary" @click="editorFn(2)">保存</el-button>
          <el-button size="small" @click="cancelFn2">取消</el-button>
        </div>
      </el-form-item>
      <el-form-item label="项目所属地区：">
        <div class="form-item-text">
          <span :class="{ mr5: projectDetailData.province_name }">
            {{ projectDetailData.province_name }}
          </span>
          <span :class="{ mr5: projectDetailData.city_name }">{{
            projectDetailData.city_name
          }}</span>
          <span :class="{ mr5: projectDetailData.area_name }">{{
            projectDetailData.area_name
          }}</span>
          <span>{{ projectDetailData.address }}</span>
        </div>
      </el-form-item>
      <el-form-item label="项目介绍：" class="project_desc">
        <div class="form-item-text" v-html="projectDetailData.description"></div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { EditorProjectInfo, ProjectGradeApi } from "@/api/tearcher";
export default {
  props: {
    projectDetailData: {
      type: Object,
    },
    show: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    // 编辑
    updateBtn2() {
      this.is_show2 = false;
      this.projectName = this.formData.projectName;
    },
    // 取消
    cancelFn2() {
      this.is_show2 = true;
      this.projectName = "";
    },
    // 编辑
    updateBtn() {
      this.is_show = false;
      this.projectCode = this.formData.projectCode;
    },
    // 取消
    cancelFn() {
      this.is_show = true;
      this.projectCode = "";
    },
    // 提交修改
    editorFn(type) {
      EditorProjectInfo({
        id: this.projectDetailData.id, // 项目id
        project_number: this.projectCode.trim(),
        project_type: this.formData.projectType,
        project_level: this.formData.projectGrade,
        project_model: this.formData.projectModel,
        note: this.projectName.trim(),
      }).then((res) => {
        this.$message({
          showClose: true,
          message: "修改成功",
          type: "success",
        });
        this.is_show = true;
        this.is_show2 = true;
        this.is_who = type; //
        this.$emit("ProjectDetailFn");
      });
    },
  },
  data() {
    return {
      formData: {},
      projectGradeArr: [], //项目级别
      projectTypeArr: [], //项目类型
      is_show: true,
      projectCode: "",
      is_show2: true,
      //   is_have: true,
      //   is_ellipsis: false,
      //   is_ellipsis2: false,
      //   is_have2: true,
      is_who: 2, // 1项目编码,2项目备注
      projectName: "",
      projectModel: [
        { id: 0, name: "线下" },
        { id: 1, name: "混合" },
        { id: 3, name: "集中" },
        { id: 4, name: "远程" },
      ],
      rules: {
        organizer: [{ required: true, message: "请输入主办单位", trigger: "blur" }],
        undertaker: [{ required: true, message: "请输入主办单位", trigger: "blur" }],
        projectType: [{ required: true, message: "请输入主办单位", trigger: "blur" }],
        projectGrade: [{ required: true, message: "请输入主办单位", trigger: "blur" }],
        projectModel: [{ required: true, message: "请输入主办单位", trigger: "blur" }],
      },
    };
  },
  watch: {
    projectDetailData: {
      handler(newVal) {
        console.log(newVal, "mewVal");
        let { project_number, project_type, project_level, project_model, note } = newVal;
        this.$set(this.formData, "projectCode", project_number);
        this.$set(this.formData, "projectType", project_type);
        this.$set(this.formData, "projectGrade", project_level);
        this.$set(this.formData, "projectModel", project_model);
        this.$set(this.formData, "projectName", note);
        this.projectName = note;
        this.projectCode = project_number;
      },
      deep: true,
    },
  },
  created() {
    // 2:项目级别
    ProjectGradeApi(2).then((res) => {
      this.projectGradeArr = res.data;
    });
    // 1:项目类型
    ProjectGradeApi(1).then((res) => {
      this.projectTypeArr = res.data;
    });
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  .el-form-item {
    width: 50%;
    margin-right: 0;
    margin-bottom: 0;
    margin-left: -30px;
    .el-form-item__label {
      font-weight: 400;
    }
    .el-input__inner {
      height: 30px;
      width: 217px;
    }
  }
  .project_desc {
    display: block;
    display: flex;
    width: 100%;
    .el-form-item__label {
      /* width: 166px; */
    }
    .el-form-item__content {
      width: 88%;
    }
  }
  .note {
    /* display: flex; */
    .note_content {
      max-width: 300px;
      display: inline-block;
    }
  }
  .btn_cls {
    padding-top: 20px;
    margin-left: 0;
  }
}
</style>
